import { Joi, objectSchemaOf, actionCreator } from '../helpers';
import { VISION_INPUT } from './topics';
import type { PersonType } from './personIdentified';
import { personTypesSchema } from './personIdentified';

export const FACE_PERSON_TYPE = 'VISION/FACE_PERSON_TYPE' as const;

export interface IFacePersonTypeActionPayload {
  faceId: string;
  type: PersonType;
  staffId?: string;
  visitorId?: string;
}

export interface IFacePersonTypeAction {
  type: typeof FACE_PERSON_TYPE;
  payload: IFacePersonTypeActionPayload;
}

export const facePersonTypeActionSchema = objectSchemaOf<IFacePersonTypeAction>(
  {
    type: Joi.string().valid(FACE_PERSON_TYPE).required(),
    payload: objectSchemaOf<IFacePersonTypeActionPayload>({
      faceId: Joi.string().required(),
      type: personTypesSchema.required(),
      staffId: Joi.string().optional(),
      visitorId: Joi.string().optional(),
    }).required(),
  }
);

export const facePersonType = actionCreator({
  type: FACE_PERSON_TYPE,
  schema: facePersonTypeActionSchema,
  topic: VISION_INPUT,
});
